// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2m-2";
export var placeholderIcon = "_2m-3";
export var thumbnailCanvas = "_2m-1";
export var thumbnailWrapper = "_2m-0";